module.exports = __webpack_public_path__ + "img/javis-small.7a8b7627.png";